import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Carlos M.',
  city: 'CDMX, MX',
  quote: 'Llevaba meses dando vueltas hasta las 2am. La primera semana con la descarga de 6 minutos, me dormí antes de la medianoche. No lo podía creer.',
  weeks: '2 semanas'
}, {
  name: 'Andrea L.',
  city: 'Medellín, CO',
  quote: 'El guión de desenganche me cambió todo. Antes peleaba con mis pensamientos. Ahora los dejo pasar y me duermo.',
  weeks: '3 semanas'
}, {
  name: 'Roberto S.',
  city: 'Santiago, CL',
  quote: 'Lo que más me dolía era el miedo al día siguiente. Ahora aunque una noche sea difícil, ya no es catástrofe.',
  weeks: '2 semanas'
}, {
  name: 'Marta C.',
  city: 'Lima, PE',
  quote: 'Trabajo 12 horas. Llegaba destruida pero mi mente no paraba. El ritual mínimo me da la señal de «ya terminó».',
  weeks: '4 semanas'
}, {
  name: 'Luis P.',
  city: 'Madrid, ES',
  quote: 'Probé melatonina, apps, ruido blanco. Nada sostenible. Esto es diferente porque es un sistema, no un hack.',
  weeks: '6 semanas'
}, {
  name: 'Daniela R.',
  city: 'Buenos Aires, AR',
  quote: 'La cama dejó de ser un ring. Eso solo ya vale todo.',
  weeks: '3 semanas'
}];
export default function TestimonialsSection() {
  return <div className="py-10 px-4 sm:px-6 lg:px-8 bg-brand-cream" data-id="element-388">
      <div className="max-w-6xl mx-auto" data-id="element-389">
        <h3 className="font-heading text-2xl md:text-3xl text-white text-center mb-1 tracking-wide uppercase" data-id="element-390">
          Resultados reales
        </h3>
        <p className="text-sm text-slate-400 text-center mb-8" data-id="element-391">
          Personas que recuperaron sus noches con APAGA LA MENTE
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-392">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07,
          duration: 0.35
        }} className="bg-gradient-to-br from-brand-navy to-brand-charcoal rounded-xl p-6 border border-white/5 shadow-lg relative overflow-hidden group hover:border-brand-indigo/30 transition-colors" data-id="element-393">
              <div className="absolute top-0 right-0 w-20 h-20 bg-brand-indigo/5 rounded-full blur-2xl -mr-10 -mt-10 group-hover:bg-brand-indigo/10 transition-colors" data-id="element-394" />

              <div className="relative z-10" data-id="element-395">
                <div className="flex items-center gap-0.5 mb-3" data-id="element-396">
                  {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-brand-amber text-brand-amber" data-id="element-397" />)}
                </div>
                <p className="text-slate-300 text-sm leading-relaxed mb-4 italic" data-id="element-398">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 border-t border-white/5 pt-3" data-id="element-399">
                  <div className="w-8 h-8 rounded-full bg-brand-indigo/20 flex items-center justify-center text-xs font-bold text-brand-indigo" data-id="element-400">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-401">
                    <p className="font-semibold text-white text-xs" data-id="element-402">{t.name}</p>
                    <p className="text-slate-500 text-[10px]" data-id="element-403">
                      {t.city} · {t.weeks}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}